// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__BmGeO","item":"Faq_item__mGRod","question":"Faq_question__wCi7L","chevron":"Faq_chevron__rWkiM","answer":"Faq_answer__5UmfS"};